module.exports = __webpack_public_path__ + "img/article_banner.c7b7bba9.png";